import { render, staticRenderFns } from "./ContactBTN.vue?vue&type=template&id=b2978b72&scoped=true&"
import script from "./ContactBTN.vue?vue&type=script&lang=js&"
export * from "./ContactBTN.vue?vue&type=script&lang=js&"
import style0 from "./ContactBTN.vue?vue&type=style&index=0&id=b2978b72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2978b72",
  null
  
)

export default component.exports